module.exports = __webpack_public_path__ + "media/images/favicon-c3542d53db4243a1288e114b382b60dc.ico";